import { toastWarning } from "../toasts/toast";

export default   function validandoQtdEmprestimos(e) {
    if (e === 0) {
      toastWarning("Quantidade de livros insuficientes.");
      return true;
    }
    return false;
  }